import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerCrossedFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m18.244 19.517 3.486 3.486 1.273-1.273L2.273 1 1 2.273 6.418 7.69c-1.63.386-1.922 1.472-1.922 4.305 0 3.938.563 4.5 4.5 4.5q.232 0 .45-.002.482.324 1.023.683l3.163 2.105c2.2 1.465 3.3 2.197 4.082 1.364.246-.262.415-.63.53-1.129m.252-4.834-7.931-7.931 3.067-2.042c2.2-1.464 3.3-2.197 4.082-1.363.782.833.782 2.737.782 6.544z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SpeakerCrossedFilledSize24Glyph.displayName = 'SpeakerCrossedFilledSize24Glyph';
